//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custfacts', {
//        templateUrl: 'views/components/views/custfacts/custfacts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'custFactsService', function ($stateParams, stateService, utilityService, modalService, translateService, custFactsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custNo = $stateParams.cust_no;

//            let translations = {
//            	error: '',
//            	ok: ''
//            };

//            vm.model = {
//                setting: {},
//                inputListCustomerFacts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSettings() {
//                vm.model.setting = (await custFactsService.getCustomerFacts({ cust_no: custNo }))[0];
//            }

//            async function loadCustomerFacts() {
//                if (utilityService.validateParmsValue(vm.model.setting.cust_no) !== true) return;

//                return vm.model.inputListCustomerFacts = await custFactsService.listCustomerFacts(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let mergeObj = vm.model.setting;
//                mergeObj.custfacts = vm.model.inputListCustomerFacts;

//                custFactsService.saveObj(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSettings();
//                loadCustomerFacts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
